export default __webpack_public_path__ + "static/media/beheard-survey-mobile.f6a562b9.mov";